import React, { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";

const dictionaries = { fr, en };

const I18nContext = createContext({ lang: "fr", t: (k) => k });

function resolve(dict, path) {
  const parts = path.split(".");
  let cur = dict;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

export function I18nProvider({ children, forcedLang }) {
  const params = useParams();
  const lang = forcedLang || (params.lang === "en" ? "en" : "fr");

  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.fr;
    const t = (key) => {
      const val = resolve(dict, key);
      if (val === undefined || val === null) return key;
      return val;
    };
    return { lang, t, dict };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useTranslation() {
  return useContext(I18nContext);
}
